// src/features/treinos/components/LiveWorkoutWidget.jsx
//
// Card flutuante GLOBAL (Parte D). Aparece em QUALQUER tela enquanto houver
// sessão ATIVA e MINIMIZADA. "Voltar ao treino" = openSession. O X NÃO encerra
// a sessão — só oculta o card temporariamente (encerrar é só dentro da tela).

import React, { useEffect, useState } from "react";
import { FaTimes, FaPlay } from "react-icons/fa";
import { useLiveWorkout, useLiveWorkoutTimer } from "../../../contexts/LiveWorkoutContext.jsx";
import Style from "../../../styles/features/treinos/LiveWorkoutWidget.module.css";

function fmtTimer(secs) {
  const m = Math.floor(secs / 60).toString().padStart(2, "0");
  const s = (secs % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
}

export default function LiveWorkoutWidget() {
  const {
    hasActiveSession,
    open,
    session,
    currentEx,
    metrics,
    openSession,
  } = useLiveWorkout();
  const { elapsed } = useLiveWorkoutTimer();

  const [hidden, setHidden] = useState(false);

  // Volta a aparecer sempre que uma nova sessão começa (ou some o full-screen).
  useEffect(() => { if (hasActiveSession) setHidden(false); }, [session?.sessaoId, hasActiveSession]);

  if (!hasActiveSession || open || hidden) return null;

  const exNome = currentEx?.NOME || "—";
  const grupo = currentEx?.MUSCLE_GROUP || session?.nomeTreino || "";
  const doneInEx = currentEx ? currentEx.rows.filter((r) => r.done).length : 0;
  const totalInEx = currentEx ? currentEx.rows.length : 0;

  return (
    <div className={Style.wrap} role="region" aria-label="Treino ao vivo">
      <button
        type="button"
        className={Style.closeX}
        onClick={(e) => { e.stopPropagation(); setHidden(true); }}
        aria-label="Ocultar card (a sessão continua)"
      >
        <FaTimes size={12} />
      </button>

      <button type="button" className={Style.card} onClick={openSession}>
        <div className={Style.topRow}>
          <span className={Style.liveLabel}>Treino ao vivo</span>
          <span className={Style.statusDot}>● Em andamento</span>
        </div>

        <div className={Style.midRow}>
          <span className={Style.timer}>{fmtTimer(elapsed)}</span>
          <div className={Style.exInfo}>
            {grupo && <span className={Style.grupo}>{grupo}</span>}
            <span className={Style.exNome}>{exNome}</span>
            <span className={Style.serie}>Série {Math.min(doneInEx + 1, totalInEx)}/{totalInEx}</span>
          </div>
        </div>

        <div className={Style.metrics}>
          <span><strong>{metrics.caloriasLive}</strong> kcal</span>
          <span><strong>{metrics.volumeTotal.toLocaleString("pt-BR")}</strong> kg</span>
          <span className={Style.xp}><strong>+{metrics.xpLive}</strong> XP</span>
        </div>

        <div className={Style.cta}>
          <FaPlay size={11} /> Voltar ao treino
        </div>
      </button>
    </div>
  );
}
